import { render, staticRenderFns } from "./BuyTicket.vue?vue&type=template&id=08d4f8f2"
import script from "./BuyTicket.vue?vue&type=script&lang=js"
export * from "./BuyTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports